import { render } from "./BaseChart.vue?vue&type=template&id=0ee65763&scoped=true"
import script from "./BaseChart.vue?vue&type=script&lang=js"
export * from "./BaseChart.vue?vue&type=script&lang=js"

import "./BaseChart.vue?vue&type=style&index=0&id=0ee65763&scoped=true&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee65763"]])

export default __exports__